import { makeImmutable } from "../../core/makeImmutable";
/**
 * A promotion for a whole order.
 *
 * For example: "10% off your first order"
 */
/*
  Compute Availability from:
  , availableAt: AvailableAt
  , availability: DslBuiltin.WeeklyAvailability
  , start: Restaurants.RestaurantLocalDay
  , finish: Restaurants.RestaurantLocalDay
  , archived: boolean
  , visible: boolean

  TODO:
  , requireSmsVerification: (boolean | null) in PromotionScope
*/
export class PromotionType {
    constructor(params) {
        this.id = params.id;
        this.scope = params.scope;
        this.effect = params.effect;
        this.availabilitySpec = params.availabilitySpec;
        this.autoselect = params.autoselect;
        this.combinesWith = params.combinesWith;
        makeImmutable(this);
    }
}
